import { render, staticRenderFns } from "./NavMenuLink.vue?vue&type=template&id=794c1508&scoped=true&"
import script from "./NavMenuLink.vue?vue&type=script&lang=js&"
export * from "./NavMenuLink.vue?vue&type=script&lang=js&"
import style0 from "./NavMenuLink.vue?vue&type=style&index=0&id=794c1508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794c1508",
  null
  
)

export default component.exports